import { render, staticRenderFns } from "./newsHome.vue?vue&type=template&id=6f237e2a&scoped=true&"
import script from "./newsHome.vue?vue&type=script&lang=js&"
export * from "./newsHome.vue?vue&type=script&lang=js&"
import style0 from "./newsHome.vue?vue&type=style&index=0&id=6f237e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f237e2a",
  null
  
)

export default component.exports